import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ServiceSelectionDto } from 'src/app/services/dtos';

@Component({
	selector: 'app-service-selection-confirm-dialog',
	templateUrl: './service-selection-confirm-dialog.component.html',
	styleUrls: ['./service-selection-confirm-dialog.component.scss']
})
export class ServiceSelectionConfirmDialogComponent {

	@Input() serviceSelection: ServiceSelectionDto;
	@Output() confirmed = new EventEmitter<boolean>();

	constructor(translate: TranslateService, public activeModal: NgbActiveModal) { }

	isOtpMethodEmail() {
		return this.serviceSelection.email !== undefined;
	}


	onConfirm() {
		this.activeModal.close(true);
	}

	onCancel() {
		this.activeModal.close(false);
	}

}
